import { createAction } from 'redux-act';
import {
    IGetComments,
    IGetCommentsResponse,
    ILeaveComment,
    ILeaveCommentResponse,
    IReactToComment,
    types,
} from './types';
import { IGenericDocumentModifier } from '../../types/global/helper';
import { IErrorType } from '../../constants/types';
import { ILikeResponse } from '../account/types';

export const getComment = createAction<IGetComments>(types.GET_COMMENTS);
export const getCommentSuccess = createAction<IGetCommentsResponse>(types.GET_COMMENTS_SUCCESS);
export const getCommentFail = createAction<IGetComments>(types.GET_COMMENTS_FAIL);

export const leaveComment = createAction<ILeaveComment>(types.LEAVE_COMMENT);
export const leaveCommentSuccess = createAction<ILeaveCommentResponse>(types.LEAVE_COMMENT_SUCCESS);
export const leaveCommentFail = createAction<IErrorType>(types.LEAVE_COMMENT_FAIL);

export const deleteComment = createAction<IGenericDocumentModifier>(types.DELETE_COMMENT);
export const deleteCommentSuccess = createAction<IGenericDocumentModifier>(types.DELETE_COMMENT_SUCCESS);
export const deleteCommentFail = createAction<IErrorType>(types.DELETE_COMMENT_FAIL);

export const updateComment = createAction<IGenericDocumentModifier>(types.UPDATE_COMMENT);
export const updateCommentSuccess = createAction<IGenericDocumentModifier>(types.UPDATE_COMMENT_SUCCESS);
export const updateCommentFail = createAction<IErrorType>(types.UPDATE_COMMENT_FAIL);

export const likeComment = createAction<IReactToComment>(types.LIKE_COMMENT);
export const likeCommentSuccess = createAction<ILikeResponse>(types.LIKE_COMMENT_SUCCESS);
export const likeCommentFail = createAction<IErrorType>(types.LIKE_COMMENT_FAIL);

export const deleteCommentLike = createAction<IGenericDocumentModifier>(types.DELETE_COMMENT_LIKE);
export const deleteCommentLikeSuccess = createAction<IGenericDocumentModifier>(types.DELETE_COMMENT_LIKE_SUCCESS);
export const deleteCommentLikeFail = createAction<IErrorType>(types.DELETE_COMMENT_LIKE_FAIL);
